import axios, { pluckData } from 'src/utilities/http-client'
import { downloadFile } from 'src/v3/utilities/filesystem'

/**
 * Extract certificate type from a course type string that may contain
 * formats like "External - Live", "External - Recorded", "Live Class", etc.
 * @param courseType - The course type string from the API
 * @returns 'external', 'live', or 'recorded'
 */
export let extractCertificateType = (
  courseType: string | undefined,
): 'live' | 'recorded' | 'external' => {
  let type = courseType || ''

  // Check if the type contains "External" (e.g., "External - Live" or "External - Recorded")
  if (type.toLowerCase().includes('external')) {
    return 'external'
  }

  // Check for live class indicators
  if (type.toLowerCase().includes('live') || type === 'Live Class') {
    return 'live'
  }

  // Default to recorded
  return 'recorded'
}

export let getCertificateUrl = (id: string, type: string): Promise<string> =>
  axios.get(`/api/v2/manage/certificate/export/${id}/${type}`).then(pluckData)

export let downloadCertificateFile = async (
  certificateID: string,
  certificateType: 'live' | 'recorded' | 'external',
  filename: string,
): Promise<{ success: boolean; error?: string }> => {
  try {
    let response = await getCertificateUrl(certificateID, certificateType)
    let fileResponse = await axios.get(response, { responseType: 'blob' })
    await downloadFile(fileResponse.data, filename)
    return { success: true }
  } catch (err: any) {
    return {
      success: false,
      error: `Certificate download failed: ${err?.message || 'Unknown error'}`,
    }
  }
}
